import { useMemo } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { supportedFileExtensions } from "lib/actions/files";

export function useSupportedFileExtensions(): ReadonlySet<string> {
  const { featureTwelveDUploads: hasTwelveDUploads } = useFlags();

  return useMemo(() => {
    if (!hasTwelveDUploads) return supportedFileExtensions;
    return new Set([...supportedFileExtensions, "12da"]);
  }, [hasTwelveDUploads]);
}
